export const lightThemeMixins =
  ' --color-backdrop: 229 231 235; --color-paper: 255 255 255; ';
export const darkThemeMixins =
  ' --color-backdrop: 17 24 39; --color-paper: 31 41 55;';
